export default __webpack_public_path__ + "static/undraw_Chilling_edited-e42c6027e0f3c200511753e0f9e792f0.svg";